export enum CallParticipantType {
    All = 'ALL',
    Client = 'CLIENT',
    Agent = 'AGENT',
    AgentA = 'AGENT A',
    AgentB = 'AGENT B',
    Uninformed = 'UNINFORMED',
}
